const sources = [
  { text: "Learn languages with Verbatim", flag: "gb" },
  { text: "Lerne Sprachen mit Verbatim", flag: "at" },
  { text: "Naucz się języków z Verbatim", flag: "pl" },
  { text: "Leer talen met Verbatim", flag: "nl" },
  { text: "Apprenez les langues avec Verbatim", flag: "fr" },
  { text: "Aprenda idiomas con Verbatim", flag: "es" },
  { text: "Verbatim ile dilleri öğrenin", flag: "tr" },
  { text: "Aprenda idiomas com Verbatim", flag: "pt" },
];

export const LanguageWelcomeMarquee = () => {
  return (
    <section
      data-testid="sources-section"
      className="relative border-y border-white/5 py-6 overflow-hidden"
    >
      <div className="relative">
        <div className="scroll-marquee whitespace-nowrap will-change-transform">
          <div>
            {sources.map((s, i) => (
              <div
                key={`a-${i}`}
                data-testid={`source-${i}`}
                className="font-display text-3xl sm:text-4xl font-bold text-white/30 hover:text-white transition-colors flex items-center gap-3 italic"
              >
                <img
                  src={`https://flagcdn.com/${s.flag}.svg`}
                  alt={`${s.flag} flag`}
                  className="w-7 h-[15px] object-cover rounded-[1px] shrink-0"
                />
                <span>{s.text}</span>
              </div>
            ))}
          </div>
          <div>
            {sources.map((s, i) => (
              <div
                key={`b-${i}`}
                data-testid={`source-${i + sources.length}`}
                className="font-display text-3xl sm:text-4xl font-bold text-white/30 hover:text-white transition-colors flex items-center gap-3 italic"
              >
                <img
                  src={`https://flagcdn.com/${s.flag}.svg`}
                  alt={`${s.flag} flag`}
                  className="w-7 h-[15px] object-cover rounded-[1px] shrink-0"
                />
                <span>{s.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[var(--subtxt-bg)] to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[var(--subtxt-bg)] to-transparent pointer-events-none" />
      </div>
    </section>
  );
};
